import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { QuoteRevisionInfoService } from './../../services/quote-revision-info.service';
import { QuoteRevision } from './../../model/quote-revision';

@Component({
  selector: 'quote-comments-aside',
  template: require('./quote-comments-aside.component.html'),
  styles: [require('./quote-comments-aside.component.scss')]
})
export class QuoteCommentsAsideComponent implements OnInit {
  subscription: Subscription = new Subscription();
  quoteRevisions: QuoteRevision[];

  constructor(private quoteRevisionInfoService: QuoteRevisionInfoService) {}

  ngOnInit(): void {
    const qRevisions = this.quoteRevisionInfoService._quoteRevisions$.subscribe(
      revisions => {
        this.quoteRevisions = revisions;
      }
    );
    this.subscription.add(qRevisions);
  }

  onToggleAside(): void {
    this.quoteRevisionInfoService._showQuoteRevisionsAside$.next(false);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/quote-comments-aside/quote-comments-aside.component.ts